import React from "react";

export type LikeIconProps = {};

export const LikeIcon: React.FC<LikeIconProps> = ({}) => {
  return (
    <svg width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.607 10.533h4.004c.161 0 .316.063.43.175a.594.594 0 0 1 .177.423v.036a6.249 6.249 0 0 0 2.745-1.377c.417-.442.738-.963.944-1.53a4.384 4.384 0 0 0 .254-1.775c0-.67.741-1.373 1.559-1.473.522-.064 1.801.04 2.388 2.343.19.968.225 1.96.102 2.938h2.404c.36-.005.714.078 1.032.241.319.163.591.401.794.693.526.73.947 2.171-.02 4.878l-1.089 3.871a2.488 2.488 0 0 1-.875 1.454c-.455.37-1.026.571-1.615.57h-2.935c-1.085 0-3.96-.176-5.688-.878v.203a.595.595 0 0 1-.178.424.611.611 0 0 1-.429.175H5.607a.612.612 0 0 1-.43-.175.595.595 0 0 1-.177-.424V11.131a.591.591 0 0 1 .178-.423.608.608 0 0 1 .43-.175zm4.611 9.256c.89.59 3.611 1.014 5.688 1.014h2.935c.31 0 .609-.106.846-.3.238-.195.398-.466.454-.766l.012-.056 1.101-3.916.012-.04c.879-2.442.421-3.476.182-3.807a.965.965 0 0 0-.834-.427h-3.097a.603.603 0 0 1-.599-.7c.004-.015.32-1.923.012-3.144-.226-.89-.595-1.433-.983-1.45a.72.72 0 0 0-.571.32 5.53 5.53 0 0 1-.35 2.216 5.588 5.588 0 0 1-1.205 1.903c-1.109 1.094-2.765 1.577-3.603 1.764v7.389z"
        fill="#111"
      />
    </svg>
  );
};
